export function disableContextmenu() {
    document.body.addEventListener('contextmenu', function (e) {
        if (PRODUCTION) {
            e.preventDefault();
            return false;
        }
    });
}
